/**
 * Terms of Service marketing page (`/terms`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 * Statically generated; no client-side data fetching or auth dependency.
 */
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';

export default function TermsPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.terms.title')}
        description={t('marketing.terms.description')}
        path="/terms"
      />

      <section className="container mx-auto max-w-3xl px-4 py-16">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.terms.heading')}
        </h1>
        <p className="mt-4 text-xl text-muted-foreground">{t('marketing.terms.subheading')}</p>
        <p className="mt-8 leading-relaxed text-muted-foreground">{t('marketing.terms.body')}</p>
      </section>
    </MarketingLayout>
  );
}
